"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepFreeze = void 0;
var _deepFreeze = require('deep-freeze-strict');
function deepFreeze(obj) {
    _deepFreeze(obj);
}
exports.deepFreeze = deepFreeze;
